module.exports = __webpack_public_path__ + "img/award-bfa.a6d4023e.jpg";